import { render, staticRenderFns } from "./ViewCorporate.vue?vue&type=template&id=474503d1"
import script from "./ViewCorporate.vue?vue&type=script&lang=js"
export * from "./ViewCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports